import { render, staticRenderFns } from "./OpportunityMetricsTable.vue?vue&type=template&id=340158a6&scoped=true"
import script from "./OpportunityMetricsTable.vue?vue&type=script&lang=js"
export * from "./OpportunityMetricsTable.vue?vue&type=script&lang=js"
import style0 from "./OpportunityMetricsTable.vue?vue&type=style&index=0&id=340158a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340158a6",
  null
  
)

export default component.exports